import { atom } from "recoil"

export const listAllMigratedTeamsRequestIdState = atom({
  key: "atoms/organization/listAllMigratedTeamsRequestIdState",
  default: 0,
})
